module.exports = __webpack_public_path__ + "static/media/amm.770f67df.svg";